import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DropdownMenuItem } from './lib-dropdown-menu-items.model';

@Component({
  selector: 'lib-dropdown-menu',
  templateUrl: './lib-dropdown-menu.component.html',
  styleUrls: ['./lib-dropdown-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LibDropdownMenuComponent implements OnChanges {
  @Input() title = 'More';
  @Input() dropdownPosition? = 'left';
  @Input() list: DropdownMenuItem[];
  @Input() className: string;
  @Input() isDisabled: boolean;
  @Input() styleOptions? = {} as Record<string, Record<string, string>>;
  @Input() isSelectedTickVisible = false;
  @Input() isDropDownOpen = false;
  @Output() selected: EventEmitter<DropdownMenuItem> = new EventEmitter();
  defaultStyles: Record<string, Record<string, string>> = {
    menuHeadingStyles: {
      'font-size': '1.8rem',
      'letter-spacing': '0rem',
    },
    menuItemStyles: {
      'font-size': '1.8rem',
      'letter-spacing': '0rem',
      'font-weight': '300',
    },
    caretStyles: { color: 'dark-blue' },
  };
  focusIndex = 0;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  ngOnChanges(): void {
    for (const property in this.defaultStyles) {
      this.styleOptions[property] = { ...this.defaultStyles[property], ...this.styleOptions[property] };
    }
  }

  onSelect(item: DropdownMenuItem, event?: KeyboardEvent): void {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.list.forEach((item) => (item.isSelected = false));
    item.isSelected = true;
    if (!item?.disabled) {
      this.isDropDownOpen = false;
      if (item.path) {
        this.router.navigate([item.path], { relativeTo: this.route });
      }
      this.selected.emit(item);
    }
  }

  toggleActiveWithKey(event: KeyboardEvent): void {
    if (!this.isDropDownOpen) {
      event.preventDefault();
      event.stopPropagation();
      this.isDropDownOpen = true;
    }
  }

  onFocus(index: number): void {
    this.focusIndex = index;
  }

  onBlur(index: number): void {
    if (index === this.list.length - 1) {
      this.isDropDownOpen = false;
    }
  }
}
